import { createFileRoute } from '@tanstack/react-router'
import { motion } from 'framer-motion'
import { XCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/canceled')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="container mx-auto max-w-2xl p-6"
    >
      <div className="text-center mb-8">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
        >
          <XCircle className="w-20 h-20 text-red-500 mx-auto mb-4" />
        </motion.div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Månadsvis Gåva Avbruten</h1>
        <p className="text-gray-600">Din månadsvisa gåva har avbrutits</p>
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="bg-white rounded-2xl shadow-lg p-6 mb-8"
      >
        <div className="text-center space-y-4">
          <p className="text-gray-700">
            Du kommer inte längre att debiteras för din månadsvisa gåva.
          </p>
          <p className="text-sm text-gray-500">
            Tack för ditt stöd hittills. Om du vill starta en ny månadsvis gåva, klicka på knappen nedan.
          </p>
    </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="text-center"
      >
        <Button
          onClick={() => navigate({ to: '/' })}
          className="hover:bg-green-600 transition-colors"
        >
          Starta Ny Månadsvis Gåva
        </Button>
      </motion.div>
    </motion.div>
  )
}
